module.exports = __webpack_public_path__ + "img/pwa-install.6db02ec3.png";